import { Component } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { NavController, AlertController, ToastController, ModalController, LoadingController, ViewController, NavParams } from 'ionic-angular';

import { LocationPage, DetailImagePage } from '../';

import { Api, User, Reviews, Item, Dokumen, assetDocuments } from '@providers/asset/index';

// import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';


@Component({
  selector: 'page-form-documents',
  templateUrl: 'page.html'
})
export class FormDocumentsPage {

  val       : any = [];
  data_user : any = [];
  params    : any = [];

  images    : any = [];
  url_img   : any = 'x';
  base_url        = '';

  doc_module = '';
  page_title = '';

  item = {
    id            : '',
    location_name : '',
    location_id   : '',
    asset_name    : '',
    asset_id      : '',
    description   : '',
    dokument_id   : '',
    generated_name: '',
  }

  constructor(
    public navCtrl           : NavController,
    public toastCtrl         : ToastController,
    public modalCtrl         : ModalController,
    public loadingCtrl       : LoadingController,
    public viewCtrl          : ViewController,
    public alertCtrl         : AlertController,
    public navParams         : NavParams,
    public camera            : Camera,
    public api               : Api,
    public userApi           : User,
    public reviewApi         : Reviews,
    public itemApi           : Item,
    public dokumenApi        : Dokumen,
    public assetDocumentsApi : assetDocuments
  ) {

    this.base_url = this.api.url;
    this.url_img  = this.dokumenApi.file_url;

    this.doc_module         = navParams.get('doc_module');
    this.item.asset_id      = navParams.get('asset_id');
    this.item.asset_name    = navParams.get('asset_name'); 
    this.item.location_id   = navParams.get('location_id'); 
    this.item.location_name = navParams.get('location_name');

    if(this.doc_module=='calibration'){
      this.page_title = 'Calibration Documents'
    }else{
      this.page_title = 'Document Opname'
    }

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    console.log(this.item);
    loading.dismiss();

  }

  
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  viewImage(generated_name) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.url_img+this.item.generated_name
    });
    profileModal.present();
  }

  takePicture(camera=1){
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth : 1024,
      sourceType:camera
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }

  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.dokumenApi.post(params).subscribe((resp:any) => {
      this.item.dokument_id=resp.data.id;
      this.item.generated_name=resp.data.generated_name;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }


  save(){
    if(this.item.description == ''){
      this.presentToast('Documents description can not empty !');
      return;
    } 
    if(this.item.dokument_id == '' || this.item.dokument_id == undefined){
      this.presentToast('Choose document image !');
      return;
    }else{
      let loading = this.loadingCtrl.create({
        content: 'Please wait...'
      });
      loading.present();
      let params:any = {
        doc_module  : this.doc_module,
        description : this.item.description,
        location_id : this.item.location_id,
        asset_id    : this.item.asset_id,
        dokument_id : this.item.dokument_id
      };
  
      this.assetDocumentsApi.save(params).subscribe((resp:any) => {      
        loading.dismiss();
        this.navCtrl.pop();
        this.presentToast('Document data saved');
      }, (err) => {
        loading.dismiss();
      });
    }
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/asset/form_documents/page.ts